module.exports = __webpack_public_path__ + "static/media/edit-icon.b2c6c5ff.svg";